import { render, staticRenderFns } from "./TeachSponsorDetails.vue?vue&type=template&id=74809cd2&"
import script from "./TeachSponsorDetails.vue?vue&type=script&lang=js&"
export * from "./TeachSponsorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports